import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MissionClientService } from './mission-client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [MissionClientService],
})
export class MissionClientModule {}
